import { render } from "./Test.vue?vue&type=template&id=2dd1dee5"
import script from "./Test.vue?vue&type=script&lang=js"
export * from "./Test.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/File/Test.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2dd1dee5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2dd1dee5', __exports__)) {
    api.reload('2dd1dee5', __exports__)
  }
  
  module.hot.accept("./Test.vue?vue&type=template&id=2dd1dee5", () => {
    api.rerender('2dd1dee5', render)
  })

}


export default __exports__